import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import {
    Box,
    Typography,
    IconButton,
    Stack,
    Divider,
} from "@mui/material";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { formatToLongDate } from "../../utils/formatToLongDate";

const ArrivedListFolder = ({
    list,
    openList,
    onEditList,
}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [listName, setListName] = useState("");
    const [listDate, setListDate] = useState("");

    // INITIALIZED
    useEffect(() => {
        if (openList) {
            setListName(list?.ListName || "");
            setListDate(list?.DateArrived || "");
        }
    }, [openList, list]);

    const handleClickMenu = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleFunctionMenu = async (typeMenu) => {
        handleCloseMenu();

        if (typeMenu === "toRename") {
            onEditList();
            return;
        } else if (typeMenu === "toDelete") {
            handleDeleteList();
            return;
        }
    };

    const handleDeleteList = async () => {

        Swal.fire({
            title: "Confirm delete?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
        }).then((result) => {

            if (result.isConfirmed) {
                console.log("deleted");
            }
        });
    };

    return (

        <>
            <Box
                onClick={() => openList(list)}
                sx={{
                    width: "100%",
                    minWidth: 330,
                    cursor: "pointer",
                    transition: "0.2s ease",

                    "&:hover .folder-body": {
                        backgroundColor: "#f1f5f9",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
                        transform: "translateY(-2px)",
                    },
                }}
            >

                {/* Folder Body */}
                <Box
                    className="folder-body"
                    sx={{
                        position: "relative",
                        backgroundColor: "#F8FAFC",
                        border: "1px solid #E2E8F0",
                        borderRadius: 1,
                        p: 2,
                        overflow: "hidden",
                        transition: "box-shadow 0.2s ease, transform 0.2s ease",

                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "3px",
                            backgroundColor:
                                list?.Cargo === "Sea Cargo"
                                    ? "#15803D"
                                    : list?.Cargo === "Air Cargo"
                                        ? "#0369A1"
                                        : "#f54e4e",
                        },
                    }}
                >
                    {/* TOP */}
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                    >
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    color: "#222",
                                    lineHeight: 1.2,
                                }}
                            >
                                {listName}
                            </Typography>

                            <Typography
                                style={{
                                    display: "inline-flex",
                                    padding: "2px 0px",
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: "#374151",
                                }}
                            >
                                {formatToLongDate(listDate)}
                            </Typography>
                        </Box>

                        {/* MENU BUTTON */}
                        <IconButton
                            className="menu-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClickMenu(e);
                            }}
                            size="small"
                            sx={{
                                opacity: 0.7,
                                transition: "0.2s ease",
                                borderRadius: 1,
                                border: "1px solid #d5d5d5",
                                backgroundColor: "#f8f8f8",

                                "&:hover": {
                                    backgroundColor: "#e7e7e7",
                                },
                            }}
                        >
                            <MoreHorizIcon
                                sx={{
                                    fontSize: 18,
                                    color: "#555",
                                }}
                            />
                        </IconButton>
                    </Stack>

                    <Divider sx={{ my: 1.5 }} />

                    <Stack
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Typography
                            sx={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#777",
                            }}
                        >
                            Items: {list?.TotalItems || 0}
                        </Typography>
                        <Typography style={{
                            display: "inline-flex",
                            padding: "2px 8px",
                            borderRadius: 3,
                            fontSize: 11,
                            fontWeight: 700,
                            whiteSpace: "nowrap",

                            backgroundColor:
                                list?.Cargo === "Sea Cargo"
                                    ? "#DCFCE7"
                                    : list?.Cargo === "Air Cargo"
                                        ? "#E0F2FE"
                                        : "#fff",

                            color:
                                list?.Cargo === "Sea Cargo"
                                    ? "#15803D"
                                    : list?.Cargo === "Air Cargo"
                                        ? "#0369A1"
                                        : "#000",
                        }}>
                            {list?.Cargo || ""}
                        </Typography>
                    </Stack>

                </Box>

            </Box>

            {/* MENU */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        px: 1,
                        mt: 1,
                        minWidth: 220,
                        borderRadius: 1.2,
                        border: "1px solid #e0e0e0",
                        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                        overflow: "hidden",

                        "& .MuiMenuItem-root": {
                            gap: 1.2,
                            py: 1.1,
                            fontSize: 14,
                            transition: "0.15s ease",

                            "&:hover": {
                                backgroundColor: "#e5effa",
                            },
                        },
                    },
                }}
            >

                <MenuItem sx={{ borderRadius: 1 }} onClick={() => handleFunctionMenu("toRename")}>
                    <EditDocumentIcon
                        sx={{ fontSize: 18 }}
                        color="info"
                    />
                    Edit List
                </MenuItem>

                <Divider />

                <MenuItem
                    onClick={() => handleFunctionMenu("toDelete")}
                    sx={{
                        borderRadius: 1,
                        color: "error.main",

                        "&:hover": {
                            backgroundColor: "#ffebee !important",
                        },
                    }}
                >
                    <DeleteForeverIcon
                        sx={{ fontSize: 18 }}
                        color="error"
                    />
                    Delete
                </MenuItem>
            </Menu>

            {/* <EditArrivedList
                open={openEditList}
                onClose={() => setOpenEditList(false)}

                list={list}
                onUpdate={(val) =>
                    setOrderList(prev =>
                        prev.map(item =>
                            item.ListID === list.ListID
                                ? {
                                    ...item,
                                    ListName: val.listName,
                                    Cargo: val.listCargo,
                                    DateArrived: val.listDate,
                                }
                                : item
                        )
                    )
                }
            /> */}
        </>
    );
};

export default ArrivedListFolder;